import { Consent } from './model/Consent';

const mapConsents = (consent: Consent[]): boolean[] => {
    return consent.map(() => { return false; });
};

export default mapConsents;
